import script from "./shiny-text.vue?vue&type=script&setup=true&lang=js"
export * from "./shiny-text.vue?vue&type=script&setup=true&lang=js"

import "./shiny-text.vue?vue&type=style&index=0&id=305d3efc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-305d3efc"]])

export default __exports__